import MQTTOptOut from './MQTTOptOut'

export default MQTTOptOut
